/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/author-questions';

const styles = {
  root: css`
    height: 50px;
    display: flex;
    align-items: center;
  `,
  name: css`
    padding-left: var(--cds-spacing-400);
  `,
  date: css`
    padding-left: var(--cds-spacing-400);
  `,
};

const WidgetSelectionListHeader = () => (
  <header css={styles.root}>
    <Grid item xs={8}>
      <Typography2 component="h3" variant="subtitleMedium" css={styles.name}>
        {_t('Name')}
      </Typography2>
    </Grid>
    <Grid item xs={4}>
      <Typography2 component="h3" variant="subtitleMedium" css={styles.date}>
        {_t('Last Updated')}
      </Typography2>
    </Grid>
  </header>
);

export default WidgetSelectionListHeader;
